import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {UmpireSquad} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';

@Injectable()
export class SquadService implements CrudService<UmpireSquad> {
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    stuff: Partial<UmpireSquad>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquad>> {
    return this.http
      .post<UmpireSquad>(
        '/squads',
        serialize({stuff, includeNames: ['season', 'team']}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireSquad[]>> {
    return this.http
      .get('/squads', {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquad>> {
    return this.http
      .get(`/squads/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/squads/${id}`);
  }

  update(
    body: Partial<UmpireSquad>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquad>> {
    return this.http
      .patch<JsonApiResponse<UmpireSquad>>(
        `/squads/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
